<template>
  <el-dialog :title="dialogName" v-dialogDrag:{dialogDrag}=true :visible.sync="dialogVisible" width="1800px" :close-on-click-modal="false">
    <div class="main-box main-content" style="height: 600px;">
      <el-steps :active="active" finish-status="success" align-center simple>
        <el-step title="基本信息" @click.native="clickStep(0)"  icon="el-icon-document-copy"></el-step>
        <el-step title="数据列设置" @click.native="clickStep(1)"  icon="el-icon-edit"></el-step>
        <el-step title="工具栏设置" @click.native="clickStep(2)"  icon="el-icon-edit"></el-step>
      </el-steps>

      <el-form ref="dataForm" id="dataForm" :model="temp" :rules="rules" label-suffix="：">

        <!-- 1、基本信息 -->
        <div v-if="active == 0">
          <el-row :gutter="15">
            <el-col :span="24">
              <el-form-item label-width="100px" label="数据源">
                <xr-page-select :selectName="temp.interfaceCategoryName" @cleanPageSelect="cleanCategory()" @pageSelect="categorySelect()">
                  <el-input slot="page-select-name" v-model="temp.interfaceCategoryName" readonly @focus="categorySelect()"></el-input>
                  <input slot="page-select-id" v-model="temp.interfaceCategoryId" type="hidden"></input>
                </xr-page-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item  label-width="100px" label="数据key">
                <el-input v-model="temp.dataServerKey" placeholder="列表serviceKey" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item  label="主键字段">
                <el-input v-model="temp.primaryKey" placeholder="主键字段" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label-width="100px"  label="条件区显示">
                <el-select v-model="temp.isShowSearch" style="width: 100%">
                  <el-option label="否" value="0"></el-option>
                  <el-option label="是" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 2、表格列配置 -->
        <div v-if="active == 1">
          <el-row :gutter="15" v-for="(item,index) in temp.columnList" :key="index">
            <el-col :span="3">
              <el-form-item label-width="100px" label="控件类型">
                <el-select v-model="item.columnType" style="width: 100%">
                  <el-option label="文本" value="input"></el-option>
                  <el-option label="数字" value="number"></el-option>
                  <el-option label="序号" value="sn"></el-option>
                  <el-option label="列多选框" value="ck"></el-option>
                  <el-option label="列单选框" value="radio"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3" v-if="item.columnType != 'sn' && item.columnType != 'ck' && item.columnType != 'radio'">
              <el-form-item label-width="60px" label="列编码">
                <el-input v-model="item.columnField" ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="3" v-if="item.columnType != 'sn' && item.columnType != 'ck' && item.columnType != 'radio'">
              <el-form-item label-width="60px"  label="列名称">
                <el-input v-model="item.columnTitle" ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="2" v-if="item.columnType != 'sn' && item.columnType != 'ck' && item.columnType != 'radio'">
              <el-form-item label-width="80px"  label="是否居中">
                <el-select v-model="item.isCenter" style="width: 100%">
                  <el-option label="否" value="0"></el-option>
                  <el-option label="是" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item label-width="60px"  label="列宽度" prop="columnWidth">
                <el-input v-model="item.columnWidth" ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="2">
              <el-form-item label-width="60px"  label="排序号">
                <el-input v-model="item.orderNum" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2" v-if="item.columnType != 'sn' && item.columnType != 'ck' && item.columnType != 'radio'">
              <i style="color: #518de6;cursor: pointer;font-size: 20px;margin-top: 5px;margin-left: 10px" class="el-icon-remove-outline" @click="delColumn(index)"></i>
            </el-col>
          </el-row>

          <el-row :gutter="15">
            <el-col :span="24">
              <el-button type="primary" @click="addColumn">增加一列</el-button>
              <el-button type="primary" @click="addColumnFormDataSource">数据源拉取</el-button>
            </el-col>
          </el-row>
        </div>

        <!-- 2、表格列配置 -->
        <div v-if="active == 2">
          <el-row :gutter="15" v-for="(item,index) in temp.toolbarList" :key="index">
            <el-col :span="3">
              <el-form-item label-width="100px"  label="名称">
                <el-input v-model="item.toolbarText" ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="3">
              <el-form-item label-width="100px"  label="图标">
                <el-input v-model="item.toolbarIconCls" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label-width="70px"  label="顺序号">
                <el-input v-model="item.orderName" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <i style="color: #518de6;cursor: pointer;font-size: 20px;margin-top: 5px;margin-left: 10px" class="el-icon-remove-outline" @click="delToolbar(index)"></i>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="3">
              <el-button type="primary" @click="addToolbar">增加一列</el-button>
            </el-col>
          </el-row>
        </div>
        <!-- 数据源选择 -->
        <page-select-dialog ref="pageSelectDialog" type="interfaceCategory"  @confirmMethod="pageSelectCallback(arguments)"></page-select-dialog>

      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <xr-button type="primary" @click="preStep()" v-show="active != 0">上一步</xr-button>
      <xr-button type="primary" @click="nextStep()" v-show="active != 2">下一步</xr-button>
      <xr-button type="primary" @click="save('dataForm')" v-show="active == 2">保存</xr-button>
      <xr-button type="default" @click="dialogVisible = false">取消</xr-button>
    </div>
  </el-dialog>
</template>
<script>

import Second from "../../../../views/common/Second.vue";

export default {
  name: "normalTableTemplate",
  data() {
    return {
      dialogName: '普通表格配置',
      dialogVisible: false,                                        //弹框
      pageId: '',                                                  //页面主键ID
      active: 0,                                                   //页面步骤
      temp:{
        pageId: '',                                                //页面ID
        interfaceCategoryId: '',                                   //主键ID
        interfaceCategoryName: '',                                 //所属页面类别
        dataServerKey: '',                                         //数据源的key
        primaryKey: '',                                            //主键字段
        isShowSearch: '0',                                         //是否显示条件区
        columnList: [],                                            //表格列
        toolbarList: [],                                           //工具栏
      },
      rules: {
        pageName: [
          { message: '页面名称不能为空!', required: true, trigger: 'blur' }
        ],
        pageCode: [
          { message: '页面编码不能为空!', required: true, trigger: 'blur' }
        ],
      }
    }
  },
  components: {
    Second

  },
  methods: {
    init(pageId){
      this.dialogVisible = true;
      this.pageId = pageId;
      this.temp.pageId = pageId;
    },

    //下一步
    nextStep(){

      //如果是第一步的时候，验证
      if(this.active === 0 && (this.temp.interfaceCategoryId == null || this.temp.interfaceCategoryId == '' || this.temp.interfaceCategoryId == undefined)){
        this.$message({message: '请选择数据源！',type: 'warning', duration: 1500})
        return false;
      }

      if(this.active <= 2){
        this.active += 1
      }
    },
    //上一步
    preStep(){
      if(this.active > 0){
        this.active -= 1
      }
    },
    //点击步骤
    clickStep(value){
      this.active = value
    },

    cleanCategory(){
      this.temp.interfaceCategoryId = '';
      this.temp.interfaceCategoryName = '';
    },
    categorySelect(){
      this.$nextTick(()=>{
        this.$refs.pageSelectDialog.init() //初始化页面
      })
    },
    //pageSelect确定
    pageSelectCallback(msg){
      let result = msg[0];
      this.temp.interfaceCategoryId = result.id
      this.temp.interfaceCategoryName = result.categoryName

      let categoryCode = result.categoryCode;
      this.temp.dataServerKey = categoryCode + '_list';
    },

    //【数据列】增加一行
    addColumn(){
      let obj = new Object();
      obj['columnType'] = 'txt';
      obj['isCenter'] = '0';
      this.temp.columnList.push(obj);
    },
    //【数据列】从数据源拉取
    addColumnFormDataSource(){
      //如果没有选择数据源，提示用户。
      if(!this.temp.interfaceCategoryId){
        this.$message.warning('未设置数据源，不能拉取！');
        return false;
      }
      return this.request({
        method:'post',
        url:'/web/service',
        params:{
          'method':'tGenerateTableColumn_listByCategoryId',
          'categoryId': this.temp.interfaceCategoryId
        }
      }).then((response) =>{          //这里使用了ES6的语法
        // 请求成功返回的数据
        //如果返回编码不为0，提示失败语
        if(response.code != '0'){
          this.$message.error(response.msg);
          return false;
        }
        //获取列表
        if(response.rows && response.rows.length > 0){
          let rows = response.rows;
          for (let i = 0; i < rows.length; i++) {
            let info = rows[i];
            let javaField = '';
            let columnComment = '';
            if(!!info.javaField){
              javaField = info.javaField;
            }
            if(!!info.columnComment){
              columnComment = info.columnComment;
            }
            let obj = new Object();
            obj['columnField'] = javaField;
            obj['columnTitle'] = columnComment;
            obj['columnType'] = 'txt';
            obj['isCenter'] = '0';
            this.temp.columnList.push(obj);
          }
        }

      })


      let obj = new Object();
      obj['columnType'] = 'txt';
      obj['isCenter'] = '0';
      this.temp.columnList.push(obj);
    },
    //【数据列】删除一行
    delColumn(index){
      this.temp.columnList.splice(index,1)
    },

    //【工具栏】增加一列
    addToolbar(){
      let obj = new Object();
      obj['toolbarText'] = '';
      obj['toolbarIconCls'] = '';
      obj['orderName'] = '';
      this.temp.toolbarList.push(obj);
    },
    //【工具栏】删除一行
    delToolbar(index){
      this.temp.toolbarList.splice(index,1)
    },
    //保存数据
    save(){
      let obj = Object.assign({}, this.temp);
      obj['columnList'] = [];        //去掉 columnList
      obj['toolbarList'] = [];       //去掉 toolbarList
      let data = this.CommonUtils.createFormData(obj);
      data.append("columnStr", JSON.stringify(this.temp.columnList))
      data.append("toolbarStr", JSON.stringify(this.temp.toolbarList))

      return this.request({
        method: 'post',
        url: '/web/service?method=tGenerateNormalTable_createNormalTable',
        data: data
      }).then((response) =>{
        if (response.code === 0) {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.dialogVisible = false
              this.$emit('initPageInfo');
            }
          })
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    //重置
    resetTemp() {
      this.temp.id = '';
      this.temp.pageName = '';
      this.temp.orderNo = '';
      this.$nextTick(() => {      //清空校验
        this.$refs['dataForm'].clearValidate()
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PageDesigner/template/normalTable/index.vue